'use client';

import cn from 'classnames';

import { Button } from '@/components/Button';
import { Link } from '@/components/Link';
import { useWindowWidth } from '@/hooks/useWindowWidth';

import s from './Banner.module.scss';

const Banner = () => {
  const {
    windowWidth,
    breakpoints: { MD },
  } = useWindowWidth();

  return (
    <section className={cn(s.root)}>
      <div className={s.top}>
        <div className={s.person}>
          <span className={s.name}>Марина Ломадзе</span>
          <span className={s.position}>Руководитель направления подбора</span>
        </div>
        {windowWidth && windowWidth <= MD && (
          <img
            src="https://cdn.cloud.ru/backend/career/banner/person.png"
            alt="person"
            width={640}
            height={600}
            className={s.image}
          />
        )}
      </div>
      <div className={s.bottom}>
        <div className={s.info}>
          <h2 className={s.title}>
            Рассказываем, как проходит интервью в нашу команду
          </h2>
          <Link withButton className={cn(s.link, 'link')} href="/stages">
            <Button
              className={s.button}
              withSlashes
              analyticsOptions={{
                action: '/stages',
                clickZone: 'body',
                clickElement: 'buttonclick',
                clickContent: 'Читать подробнее',
                uniqueId: `banner-Читать подробнее`,
                transitionType: 'inside-link',
                clickZoneCategory: 'site-body',
                transitionTypeMetrics: 'internal',
                transitionUrl: '/career/stages',
              }}
            >
              Читать подробнее
            </Button>
          </Link>
        </div>
        {windowWidth && windowWidth > MD && (
          <img
            src="https://cdn.cloud.ru/backend/career/banner/person.png"
            alt="person"
            width={640}
            height={600}
            className={s.image}
          />
        )}
      </div>
    </section>
  );
};

export { Banner };
